import { date } from 'yup';

export const AiDateSchema = date()
  .transform((_, originalValue) => {
    if (
      originalValue === 'null' ||
      originalValue === '' ||
      originalValue == null ||
      originalValue === undefined
    ) {
      return null;
    }

    const date = new Date(originalValue);
    return isNaN(date.getTime()) ? null : date;
  })
  .nullable()
  .notRequired();
